import { twMerge } from "tailwind-merge";

export type LabelProps = {
    name?: string
    text?: string
    required?: boolean
    hint?: string
    className?: string 
}

const Label = (props: LabelProps) => {
    return (
        <>
            {
                props.text && (
                    <div className="flex justify-between items-end mb-2">
                        <label 
                            htmlFor={props.name} 
                            className={twMerge(
                                "text-sm text-secondary",
                                props.required && "after:content-['*'] after:pl-1 after:text-rose-800",
                                props.className
                            )}
                        >
                            {props.text}
                        </label>

                        { 
                            props.hint && (
                            <span className="text-[10px] text-zinc-400 font-medium">
                                {props.hint}
                            </span>
                        )}
                    </div>
                )
            }
        </>
    )
}

export default Label